module.exports = __webpack_public_path__ + "files/6fdcb32dbcca8518f52fa0d8671a08d6.png";